import React, { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { setCookie } from '../../utils/cookie';
import { useNavigate } from 'react-router-dom';
import DesktopMenu from '../../common/DesktopMenu/index';
import MobileMenu from '../../common/MobileMenu/index';
import useWindowSize from '../../common/windowSize';
import NewFooter from '../../common/NewFooter';
import {
    Background,
    LoginBackground,
    LoginBackgroundImage,
    LoginTitle,
    LoginInput,
    LoginButton,
    LoginRegistration,
    LoginSubtitle
} from './styles';
import loginBackground from '../../assets/login/blue-part-login.svg';
import { publicAPI } from '../../utils/api';
import { useTranslation } from "react-i18next";

const Login = () => {
    const size = useWindowSize()
    const navigate = useNavigate()
    const [ mobileMenu, setMobileMenu ] = useState(false)
    const [ loginUser, setLoginUser] = useState({})
    const [ loading, setLoading ] = useState(false);
    const { t } = useTranslation();

    const login = async (e) => {
        e.preventDefault()
        setLoading(true)
        
        if(!loginUser.username) return [toast.error('Username is empty'), setLoading(false)]
        if(!loginUser.password) return [toast.error('Password is empty'), setLoading(false)]

        try{
            const response = await publicAPI.post(`/public/bacchus/login`, loginUser);
            const token = response.data.token;
            const decoded = jwt_decode(token);
            setCookie('token', response.data.token)
            setCookie('isAdmin', decoded.isAdmin ? decoded.isAdmin : '')
            setCookie('userName', decoded.name)
            setCookie('userId', decoded.id)
            decoded.isAdmin ? navigate("/admin-panel") : navigate("/shop") 
        } catch (error){
            setLoading(false);
            if(error.request.status === 401) return toast.error('Username or password is incorrect')
            if(error.request.status === 500) return toast.error('Internal server error')
        }
    }     

    useEffect(() => {
      if (size.width < 1200) {
        setMobileMenu(true);
      } else {
        setMobileMenu(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size]);

    return(
        <>
            {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
            <Background>
                <LoginBackground>
                    <LoginBackgroundImage src={loginBackground}/>
                    <LoginTitle>{t("login")}</LoginTitle>
                    <LoginSubtitle>{t("onlyLoggedIn")}</LoginSubtitle>
                    <LoginInput 
                        type="text" 
                        placeholder={t("email")}
                        disabled={loading}
                        onChange={(e) => setLoginUser({...loginUser,
                            username: e.target.value
                        })}
                        />
                    <LoginInput
                        type="password"
                        placeholder={t("enterPassword")}
                        disabled={loading}
                        onChange={(e) => setLoginUser({...loginUser,
                            password: e.target.value
                        })}
                        />
                    <LoginButton 
                        type="submit" 
                        value="Submit"
                        disabled={loading}
                        onClick={(e) => login(e)}
                        onKeyDown={(e) => {e.key === 13 ?? login(e)}}
                        >
                            {loading ? `${t("loading")}...` : 'Submit'}
                    </LoginButton>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: 1000 }}
                        open={loading}
                        >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <LoginRegistration onClick={() => navigate("/forgot-password")}>{t("forgotPassword")}</LoginRegistration>
                    <LoginRegistration onClick={() => navigate("/registration")}>{t("registerHere")}</LoginRegistration>
                </LoginBackground>
            </Background>
            <NewFooter/>
        </>
    )
}
export default Login;
